import { DriveFolderUpload } from "@mui/icons-material";
import { Box, Divider, Stack } from "@mui/material";
import { TemplateFieldType } from "../../../App/Enums/TemplateFieldType";
import {
  useMessageInputHandlers,
  useMessageInputState,
} from "../../../App/State/Hooks/MessageDialog/useMessageInput";
import { IEmailTemplate } from "../../../App/Typings/MessageText";
import { MemoEmailTemplateListDialog } from "../../MessageTemplates/EmailTemplateListDialog";
import MessageTemplateFields from "../../SendGroupMessage/Components/MessageTemplateFields/MessageTemplateFields";

export default function SendEmailNow({
  handleSelectedTemplateRow,
  InputEmailComponent,
}: {
  disableSaveAsTemplateButton: boolean;
  handleSelectedTemplateRow: (template: IEmailTemplate) => void;
  saveEmailTemplate: (e: any) => void;
  disableTemplateButton: boolean;
  disableTemplateMessage: string;
  InputEmailComponent: JSX.Element;
}) {
  const { handleInputSubjectChange } = useMessageInputHandlers();
  const { subject } = useMessageInputState();

  return (
    <Box>
      <Stack
        direction="row"
        alignItems={"flex-end"}
        justifyContent={"flex-end"}
        divider={<Divider orientation="vertical" flexItem />}
        spacing={2}
      >
        <Box>
          <MemoEmailTemplateListDialog
            ButtonProps={{ startIcon: <DriveFolderUpload /> }}
            buttonName={"Load Email Templates"}
            handleSelected={handleSelectedTemplateRow}
          />
        </Box>
        <Box>
          <MessageTemplateFields
            excludedTypes={[TemplateFieldType.Email, TemplateFieldType.Forms]}
            handleTemplateButtonClick={(_e, field) => {
              handleInputSubjectChange(`${subject} [[${field}]]`);
            }}
          />
        </Box>
      </Stack>
      {InputEmailComponent}
    </Box>
  );
}
